import { render, staticRenderFns } from "./pageRenderer.vue?vue&type=template&id=7505f614&"
import script from "./pageRenderer.vue?vue&type=script&lang=js&"
export * from "./pageRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports